import * as React from "react";
import classnames from "classnames";
import { Icon } from "@grandvisionhq/icons";
import { useIntl } from "@grandvisionhq/state";
/* empty css          */
const getRest = (props) => {
  const { className, index, number, label, status, hideLabel, onClick, disabled, ...rest } = props;
  return rest;
};
const getSharedProps = (props) => {
  const { className, disabled, status = "open" } = props;
  return {
    className: classnames("step", `step--${status}`, className),
    "aria-disabled": disabled,
    "aria-current": status === "active" ? "step" : void 0,
    ...disabled ? { disabled } : {}
  };
};
const Step = (props) => {
  const { onClick, disabled, label, index, hideLabel, number, status = "open" } = props;
  const onClickHandler = React.useCallback(() => {
    if (onClick && !disabled) {
      onClick(label, index);
    }
  }, [label, index, disabled, onClick]);
  if (!!onClick) {
    return /* @__PURE__ */ React.createElement("button", { ...getRest(props), ...getSharedProps(props), onClick: onClickHandler }, /* @__PURE__ */ React.createElement(StepContent, { number, hideLabel, label, status }));
  } else {
    return /* @__PURE__ */ React.createElement("div", { ...getRest(props), ...getSharedProps(props), role: "group" }, /* @__PURE__ */ React.createElement(StepContent, { number, hideLabel, label, status }));
  }
};
const StepContent = ({ number, hideLabel, label, status }) => {
  const { getLabel } = useIntl();
  const accessibleStepLabel = getLabel("common.step");
  const accessibleStatusLabel = status === "active" && getLabel("common.active") || status === "skip" && getLabel("common.skipped") || status === "done" && getLabel("common.done");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "step__number", "aria-hidden": true }, number), /* @__PURE__ */ React.createElement(Icon, { className: "step__checkmark", name: "checkmark" }), accessibleStepLabel && /* @__PURE__ */ React.createElement("span", { className: "step__visually-hidden" }, `${accessibleStepLabel} ${number}`), /* @__PURE__ */ React.createElement(
    "span",
    {
      className: classnames("step__label", {
        "step__label--hide-label": hideLabel
      })
    },
    label
  ), accessibleStatusLabel && /* @__PURE__ */ React.createElement("span", { className: "step__visually-hidden" }, ". ", accessibleStatusLabel));
};
export {
  Step as default
};
//# sourceMappingURL=Step.js.map
